const fontStyle = {
  name: "font-style",
  path: "/font-style",
  title: "font-style",
  description: "Utilities for controlling the font style of text.",
  value: {
    "font-style": {
      "italic": "italic",
      "not-italic": "normal",
    }
  },
  exampleData: [
    {
      example: {
        code: `
<p class="italic text-lg">The quick brown fox jumps over the lazy dog. (italic)</p>
<p class="not-italic text-lg">The quick brown fox jumps over the lazy dog. (not-italic)</p>
        `
      }
    }
  ],
  htmlData: [
    {
      data: `
      <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-10">
        Use <code class="text-color-gray-800 dark:text-color-white font-semibold">italic</code> or <code class="text-color-gray-800 dark:text-color-white font-semibold">not-italic</code> to control the font style:
      </p>
      <div class="space-y-6">
        <div>
            <small class="mb-3 font-mono font-medium text-color-gray-500 dark:text-color-gray-400">italic</small>
            <p class="italic text-lg">The quick brown fox jumps over the lazy dog.</p>
        </div>
        <div>
            <small class="mb-3 font-mono font-medium text-color-gray-500 dark:text-color-gray-400">not-italic</small>
            <p class="not-italic text-lg">The quick brown fox jumps over the lazy dog.</p>
        </div>
      </div>
      `
    }
  ]
}
export default fontStyle;